import { render, staticRenderFns } from "./BoardEditor.vue?vue&type=template&id=4d0aa83f&scoped=true&"
import script from "./BoardEditor.vue?vue&type=script&lang=ts&"
export * from "./BoardEditor.vue?vue&type=script&lang=ts&"
import style0 from "./BoardEditor.vue?vue&type=style&index=0&id=4d0aa83f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0aa83f",
  null
  
)

export default component.exports